import { render, staticRenderFns } from "./SvgLoaderMoon.vue?vue&type=template&id=65635708&"
import script from "./SvgLoaderMoon.vue?vue&type=script&lang=js&"
export * from "./SvgLoaderMoon.vue?vue&type=script&lang=js&"
import style0 from "./SvgLoaderMoon.vue?vue&type=style&index=0&id=65635708&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports